import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { PlanList } from '../plan-list.model';
import { PlanListActions, PlanListActionTypes } from '../actions/plan-list.actions';

export interface State extends EntityState<PlanList> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<PlanList> = createEntityAdapter<PlanList>({
  selectId: info => info.Id
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(
  state = initialState,
  action: PlanListActions
): State {
  switch (action.type) {
    case PlanListActionTypes.AddPlanList: {
      return adapter.addOne(action.payload.planList, {...state, Loaded: true, Loading: false});
    }

    case PlanListActionTypes.UpsertPlanList: {
      return adapter.upsertOne(action.payload.planList, {...state, Loaded: true, Loading: false});
    }

    case PlanListActionTypes.AddPlanLists: {
      return adapter.addMany(action.payload.planLists, {...state, Loaded: true, Loading: false});
    }

    case PlanListActionTypes.UpsertPlanLists: {
      return adapter.upsertMany(action.payload.planLists, {...state, Loaded: true, Loading: false});
    }

    case PlanListActionTypes.UpdatePlanList: {
      return adapter.updateOne(action.payload.planList, {...state, Loaded: true, Loading: false});
    }

    case PlanListActionTypes.UpdatePlanLists: {
      return adapter.updateMany(action.payload.planLists, {...state, Loaded: true, Loading: false});
    }

    case PlanListActionTypes.DeletePlanList: {
      return adapter.removeOne(action.payload.id, {...state, Loaded: true, Loading: false});
    }

    case PlanListActionTypes.DeletePlanLists: {
      return adapter.removeMany(action.payload.ids, {...state, Loaded: true, Loading: false});
    }

    case PlanListActionTypes.LoadPlanLists: {
      return adapter.setAll(action.payload.planLists, {...state, Loaded: true, Loading: false});
    }

    case PlanListActionTypes.ClearPlanLists: {
      return adapter.removeAll(state);
    }

    case PlanListActionTypes.GetAddPlanList:
    case PlanListActionTypes.GetUpdatePlanList:
    case PlanListActionTypes.GetDeletePlanList:
    case PlanListActionTypes.ConfirmPlanKey: {
      return {...state, Loaded: false, Loading: true};
    }

    case PlanListActionTypes.GetReadPlanListFails: {
      return {...state, Loaded: true, Loading: false};
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
